var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"94%","padding":"0 5% 50px 5%"}},[_c('iframe',{staticStyle:{"border":"none","width":"100%","height":"100%"},attrs:{"src":_vm.reportUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }